module.exports = __webpack_public_path__ + "static/media/c2bannerModul3_small.7a65ec68.jpg";